import { ILayout, useLayout } from '../../core'
import { FC, useEffect, useState ,useLayoutEffect} from 'react'
import { useLocation } from 'react-router-dom'
import SelectTenant from '../../../../app/modules/custom/accounts/datatransfer/components/SelectTenant'

//import { MenuInner } from './header-menus'
import { MenuInner } from './header-menus/MenuInnerV2'

const Header: FC = () => {
  const { config } = useLayout()
  useEffect(() => {
    updateDOM(config)
  }, [config])

 
  function useWindowSize() {
    const [windowSize, setWindowSize] = useState([0, 0]);
    useLayoutEffect(() => {
      function updateWindowSize() {
        setWindowSize([window.innerWidth, window.innerHeight]);
      }
      window.addEventListener("resize", updateWindowSize);
      updateWindowSize();
      return () => window.removeEventListener("resize", updateWindowSize);
    }, []);
    return windowSize;
  }

  const dimensions = useWindowSize();

  const { pathname } = useLocation();





  return (
    <div

      className='
        menu
        menu-rounded
        menu-column
        menu-lg-row
        my-5
        my-lg-2
        align-items-stretch
        fw-semibold
        px-2 px-lg-0
    '
      id='kt_app_header_menu'
      data-kt-menu='true'
    >

   { dimensions[0] > 992 && <MenuInner></MenuInner>}

    </div>
  )
}


const updateDOM = (config: ILayout) => {
  if (config.app?.header?.default?.fixed?.desktop) {
    document.body.setAttribute('data-kt-app-header-fixed', 'true')
  }

  if (config.app?.header?.default?.fixed?.mobile) {
    document.body.setAttribute('data-kt-app-header-fixed-mobile', 'true')
  }

  if (config.app?.header?.default?.stacked) {
    document.body.setAttribute('data-kt-app-header-stacked', 'true')
  }

  const appHeaderDefaultStickyEnabled = config.app?.header?.default?.sticky?.enabled
  let appHeaderDefaultStickyAttributes: { [attrName: string]: string } = {}
  if (appHeaderDefaultStickyEnabled) {
    appHeaderDefaultStickyAttributes = config.app?.header?.default?.sticky?.attributes as {
      [attrName: string]: string
    }
  }

  const appHeaderDefaultMinimizeEnabled = config.app?.header?.default?.minimize?.enabled
  let appHeaderDefaultMinimizeAttributes: { [attrName: string]: string } = {}
  if (appHeaderDefaultMinimizeEnabled) {
    appHeaderDefaultMinimizeAttributes = config.app?.header?.default?.minimize?.attributes as {
      [attrName: string]: string
    }
  }

  setTimeout(() => {
    const headerElement = document.getElementById('kt_app_header')
    // header
    if (headerElement) {
      const headerAttributes = headerElement
        .getAttributeNames()
        .filter((t) => t.indexOf('data-') > -1)
      headerAttributes.forEach((attr) => headerElement.removeAttribute(attr))

      if (appHeaderDefaultStickyEnabled) {
        for (const key in appHeaderDefaultStickyAttributes) {
          if (appHeaderDefaultStickyAttributes.hasOwnProperty(key)) {
            headerElement.setAttribute(key, appHeaderDefaultStickyAttributes[key])
          }
        }
      }

      if (appHeaderDefaultMinimizeEnabled) {
        for (const key in appHeaderDefaultMinimizeAttributes) {
          if (appHeaderDefaultMinimizeAttributes.hasOwnProperty(key)) {
            headerElement.setAttribute(key, appHeaderDefaultMinimizeAttributes[key])
          }
        }
      }
    }
  }, 0)
}

export { Header }
